import CustomPrintConfigurator from './CustomPrintConfigurator';

export default CustomPrintConfigurator;
